import { render, staticRenderFns } from "./buscadorTitular.vue?vue&type=template&id=3f64c1d8"
import script from "./buscadorTitular.vue?vue&type=script&lang=js"
export * from "./buscadorTitular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports